export default __webpack_public_path__ + "media/gogh.c901c48f.jpg";